import React from "react";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";

import Card from "../common/card";

import "./styles/works.css";

const Works = () => {
	return (
		<div className="works">
			<Card
				icon={faBriefcase}
				title="Work"
				body={
					<div className="works-body">
						<div className="work">
							<img
								src="./dyna_robotics_logo.jpg"
								alt="Dyna Robotics"
								className="work-image"
							/>
							<div className="work-content">
								<div className="work-header">
									<div className="work-title">Dyna Robotics</div>
									<div className="work-duration">Coming Soon</div>
								</div>
								<div className="work-subtitle">Member of Technical Staff, Hardware Intern</div>
							</div>
						</div>

						<div className="work">
							<img
								src="./hcrl.png"
								alt="hcrl"
								className="work-image"
							/>
							<div className="work-content">
								<div className="work-header">
									<div className="work-title">Human Centered Robotics Lab</div>
									<div className="work-duration">August 2024 - May 2026</div>
								</div>
								<div className="work-subtitle">Graduate Student Fellow</div>
							</div>
						</div>

						<div className="work">
							<img
								src="./sony.png"
								alt="sony"
								className="work-image"
							/>
							<div className="work-content">
								<div className="work-header">
									<div className="work-title">Sony Corporation - Fundamental Robotics Lab, Tokyo, Japan</div>
									<div className="work-duration">May 2024 - August 2024</div>
								</div>
								<div className="work-subtitle">Research Intern</div>
							</div>
						</div>

						<div className="work">
							<img
								src="./hcrl.png"
								alt="hcrl"
								className="work-image"
							/>
							<div className="work-content">
								<div className="work-header">
									<div className="work-title">Human Centered Robotics Lab</div>
									<div className="work-duration">January 2023 - May 2024</div>
								</div>
								<div className="work-subtitle">Undergraduate Researcher</div>
							</div>
						</div>

						<div className="work">
							<img
								src="./hero.png"
								alt="hero"
								className="work-image"
							/>
							<div className="work-content">
								<div className="work-header">
									<div className="work-title">Human-Enabled Robotics Technology Lab</div>
									<div className="work-duration">August 2021 - December 2022</div>
								</div>
								<div className="work-subtitle">Undergraduate Researcher</div>
							</div>
						</div>

						<div className="work">
							<img
								src="./samsung.png"
								alt="hero"
								className="work-image"
							/>
							<div className="work-content">
								<div className="work-header">
									<div className="work-title">Samsung Austin Semiconductor</div>
									<div className="work-duration">May 2022 - August 2022</div>
								</div>
								<div className="work-subtitle">Engineering Intern</div>
							</div>
						</div>

						<div className="work">
							<img
								src="./ut-logo.png"
								alt="fire"
								className="work-image"
							/>
							<div className="work-content">
								<div className="work-header">
									<div className="work-title">Freshman Introduction to Research in Engineering - UT Austin</div>
									<div className="work-duration">January 2021 - May 2021</div>
								</div>
								<div className="work-subtitle">Freshman Researcher</div>
							</div>
						</div>

					</div>
				}
			/>
		</div>
	);
};

export default Works;
